import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CallToAction from './CallToAction';

function SignIn() {
  const { t } = useTranslation('translations');

  return (
    <Fragment>
      <header>
        <h1>{t('Welcome!')}</h1>
      </header>
      <main>
        <section>
          <h2>{t('Users with a Sensotrend account')}</h2>
          <CallToAction action="/login">
            {t('Log In!')}
          </CallToAction>
        </section>
        <section>
        <h2>{t('New users')}</h2>
          <CallToAction action="/signup">
            {t('Registration!')}
          </CallToAction>
        </section>
      </main>
    </Fragment>
  );
}

export default SignIn;
